import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import AddAllDiagnose from "./AddAllDiagnose";
import { useDispatch } from "react-redux";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";

const diagnisis = [
  { diagnose: "Missing Tooth", color: "#000", isBtn: true, hasSurface: false, _id: "1" },
  { diagnose: "Abration", color: "#f1c40f", isBtn: true, hasSurface: true, _id: "2" },
  { diagnose: "Fracture", color: "red", isBtn: true, hasSurface: true, _id: "3" },
  { diagnose: "Attrition", color: "blue", isBtn: true, hasSurface: true, _id: "4" },
  { diagnose: "Caries", color: "green", isBtn: true, hasSurface: true, _id: "5" },
];

function DiagnoseList() {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [diagnoseOpen, setdiagnoseOpen] = useState(false);

  const getData = useCallback(() => {
    dispatch(setloadeActive());
    baseUrl
      .get("alltreatment/findAllDiagnose", { headers: { status: true } })
      .then((response) => {
        dispatch(setloadeDeactive());
        setData(response.data.data);
      })
      .catch((error) => {
        dispatch(setloadeDeactive());
        console.log(error);
      });
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [diagnoseOpen, getData]);

  const openModel = () => {
    setdiagnoseOpen(!diagnoseOpen);
  };

  const deactivate = (e: any) => {
    baseUrl
      .post("alltreatment/deactivateDiagnose", {}, { headers: { diagnoseid: e } })
      .then((response) => {
        if (response.data.success) getData();
      })
      .catch((error) => console.log(error));
  };

  const allData = [...diagnisis, ...data];

  return (
    <>
      {/* Header Card */}
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-4 mb-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-primaryLight rounded-xl flex items-center justify-center">
              <LocalHospitalIcon className="text-white" sx={{ fontSize: 20 }} />
            </div>
            <div>
              <h3 className="text-lg font-bold text-slate-800 dark:text-slate-200">Diagnose List</h3>
              <p className="text-sm text-slate-500 dark:text-slate-400 m-0">{allData.length} diagnoses</p>
            </div>
          </div>
          <button
            onClick={() => openModel()}
            className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-xl hover:shadow-lg hover:shadow-primary/20 transition-all font-medium"
          >
            <AddIcon sx={{ fontSize: 20 }} />
            Add New
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
        {/* Mobile Cards */}
        <div className="md:hidden p-4 space-y-3">
          {allData.length === 0 ? (
            <div className="text-center py-12 text-slate-400 dark:text-slate-500">
              <LocalHospitalIcon sx={{ fontSize: 48 }} className="mb-2" />
              <p>No diagnoses found</p>
            </div>
          ) : (
            allData.map((item: any, i: number) => (
              <div key={i} className="bg-slate-50 dark:bg-slate-700/50 rounded-xl p-4 border border-slate-100 dark:border-slate-600">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm"
                      style={{ backgroundColor: item?.color || "#6366f1" }}
                    >
                      {i + 1}
                    </div>
                    <div>
                      <p className="font-semibold text-slate-800 dark:text-slate-200">{item?.diagnose}</p>
                      <div className="flex items-center gap-2 mt-1">
                        <span
                          className="px-2 py-0.5 rounded-full text-xs font-medium text-white"
                          style={{ backgroundColor: item?.color || "#6366f1" }}
                        >
                          {item?.color}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-sm mb-3">
                  <div className="flex items-center gap-1">
                    {item?.isBtn ? (
                      <CheckCircleIcon className="text-emerald-500 dark:text-emerald-400" sx={{ fontSize: 16 }} />
                    ) : (
                      <CancelIcon className="text-slate-400 dark:text-slate-500" sx={{ fontSize: 16 }} />
                    )}
                    <span className="text-slate-600 dark:text-slate-400">Button</span>
                  </div>
                  <div className="flex items-center gap-1">
                    {item?.hasSurface ? (
                      <CheckCircleIcon className="text-emerald-500 dark:text-emerald-400" sx={{ fontSize: 16 }} />
                    ) : (
                      <CancelIcon className="text-slate-400 dark:text-slate-500" sx={{ fontSize: 16 }} />
                    )}
                    <span className="text-slate-600 dark:text-slate-400">Surface</span>
                  </div>
                </div>
                {i >= diagnisis.length && (
                  <div className="pt-3 border-t border-slate-200 dark:border-slate-600">
                    <button
                      onClick={() => deactivate(item?._id)}
                      className="flex items-center justify-center gap-1 w-full px-3 py-2 bg-red-50 dark:bg-red-900/40 text-red-500 dark:text-red-400 rounded-lg hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors text-sm font-medium"
                    >
                      <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                      Deactivate
                    </button>
                  </div>
                )}
              </div>
            ))
          )}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50/80 dark:bg-slate-700/50">
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  No
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Diagnose
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Button
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Color
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Has Surface
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
              {diagnisis.map((item: any, i: number) => (
                <tr key={i} className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors">
                  <td className="px-6 py-3">
                    <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-400">
                      {i + 1}
                    </span>
                  </td>
                  <td className="px-6 py-3">
                    <div className="flex items-center gap-3">
                      <div
                        className="w-3 h-3 rounded-full"
                        style={{ backgroundColor: item?.color }}
                      />
                      <span className="font-medium text-slate-800 dark:text-slate-200">{item?.diagnose}</span>
                    </div>
                  </td>
                  <td className="px-6 py-3">
                    {item?.isBtn ? (
                      <span className="px-2.5 py-1 bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 rounded-full text-xs font-medium">
                        Yes
                      </span>
                    ) : (
                      <span className="px-2.5 py-1 bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 rounded-full text-xs font-medium">
                        No
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-3">
                    <span
                      className="px-3 py-1 rounded-full text-xs font-medium text-white"
                      style={{ backgroundColor: item?.color || "#6366f1" }}
                    >
                      {item?.color}
                    </span>
                  </td>
                  <td className="px-6 py-3">
                    {item?.hasSurface ? (
                      <span className="px-2.5 py-1 bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 rounded-full text-xs font-medium">
                        Yes
                      </span>
                    ) : (
                      <span className="px-2.5 py-1 bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 rounded-full text-xs font-medium">
                        No
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-3">
                    <span className="text-xs text-slate-400 dark:text-slate-500">Default</span>
                  </td>
                </tr>
              ))}
              {data.map((item: any, i: number) => (
                <tr key={i + diagnisis.length} className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors">
                  <td className="px-6 py-3">
                    <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-400">
                      {i + diagnisis.length + 1}
                    </span>
                  </td>
                  <td className="px-6 py-3">
                    <div className="flex items-center gap-3">
                      <div
                        className="w-3 h-3 rounded-full"
                        style={{ backgroundColor: item?.color }}
                      />
                      <span className="font-medium text-slate-800 dark:text-slate-200">{item?.diagnose}</span>
                    </div>
                  </td>
                  <td className="px-6 py-3">
                    {item?.isBtn ? (
                      <span className="px-2.5 py-1 bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 rounded-full text-xs font-medium">
                        Yes
                      </span>
                    ) : (
                      <span className="px-2.5 py-1 bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 rounded-full text-xs font-medium">
                        No
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-3">
                    <span
                      className="px-3 py-1 rounded-full text-xs font-medium text-white"
                      style={{ backgroundColor: item?.color || "#6366f1" }}
                    >
                      {item?.color}
                    </span>
                  </td>
                  <td className="px-6 py-3">
                    {item?.hasSurface ? (
                      <span className="px-2.5 py-1 bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 rounded-full text-xs font-medium">
                        Yes
                      </span>
                    ) : (
                      <span className="px-2.5 py-1 bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 rounded-full text-xs font-medium">
                        No
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-3">
                    <button
                      onClick={() => deactivate(item?._id)}
                      className="p-2 rounded-lg bg-red-50 dark:bg-red-900/40 text-red-500 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors"
                      title="Deactivate"
                    >
                      <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {diagnoseOpen && <AddAllDiagnose close={setdiagnoseOpen} />}
    </>
  );
}

export default DiagnoseList;
